module.exports = __webpack_public_path__ + "img/icon-careers-blue.76c462d5.svg";